import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip"
import { cn } from "@/lib/utils"
import type { GraphItem } from "../../domain/entities/sharepoint"
import { isSelectable, selKey } from "./sharepoint-file-list"

type Props = {
  items: GraphItem[]
  selectedIds: Set<string>
  onOpenFolder: (item: GraphItem) => void
  onToggle: (item: GraphItem) => void
}

export const BrowseList = ({
  items,
  selectedIds,
  onOpenFolder,
  onToggle,
}: Props) => (
  <>
    {items.map((item) => {
      // Folders (selected as a unit) and permitted files get a checkbox;
      // non-permitted files (exe, zip, …) get none — they cannot be synced.
      const selectable = item.isFolder || isSelectable(item)
      return (
        <div
          key={item.id}
          className="flex items-center gap-3 border-b px-3 py-2.5 text-sm"
        >
          {selectable ? (
            <input
              type="checkbox"
              checked={selectedIds.has(selKey(item.driveId, item.id))}
              onChange={() => onToggle(item)}
              className="size-4 shrink-0 cursor-pointer"
            />
          ) : (
            <span className="size-4 shrink-0" aria-hidden />
          )}
          <span className="shrink-0 text-base leading-none">
            {item.isFolder ? "📁" : "📄"}
          </span>
          {item.isFolder ? (
            <Tooltip>
              <TooltipTrigger asChild>
                <button
                  className="min-w-0 flex-1 cursor-pointer truncate text-left hover:underline"
                  title={item.name}
                  onClick={() => onOpenFolder(item)}
                >
                  {item.name}
                </button>
              </TooltipTrigger>
              <TooltipContent side="top">Open folder</TooltipContent>
            </Tooltip>
          ) : (
            <span
              className={cn(
                "min-w-0 flex-1 truncate",
                !isSelectable(item) && "text-muted-foreground",
              )}
              title={item.name}
            >
              {item.name}
            </span>
          )}
        </div>
      )
    })}
  </>
)
